"use client";

import NextScript from "next/script";
import React from "react";
import type { Nullable } from "../../@types/generic";
import { useConsent, useIsPay } from "../Consent/hooks";

type Props = {
    script?: Nullable<string>;
};

export const AdDefendScript: React.FC<Props> = ({ script }) => {
    const consent = useConsent();
    const isPay = useIsPay();

    if (!consent || isPay || typeof script !== "string" || script === "") {
        return null;
    }

    return (
        <NextScript strategy="lazyOnload" id="addefend-script">
            {script}
        </NextScript>
    );
};
